import { useLayoutEffect, useState } from "react";

interface Size {
  width: number | null;
  height: number | null;
}

export default function useWindowSize() {
  const [size, setSize] = useState<Size>({ width: null, height: null });

  useLayoutEffect(() => {
    const handler = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    handler();

    window.addEventListener("resize", handler);

    return () => window.removeEventListener("resize", handler);
  }, []);

  return size;
}
